import { triageV3 } from './triage';

export const bulk_send = data =>
  triageV3({
    method: 'POST',
    url: 'sms',
    data,
  });
